<template>
    <div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box"
                    style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;padding-top: 20px;">
                    <div class="card-header">
                        <div class="clearfix">
                            <div class="pull-left">
                                <h4 class="text-black h4">Cadastro de Grupos de telas</h4>
                            </div>
                        </div>
                    </div>
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="4" v-show="false">
                                    <v-text-field v-model="GrupoTela.grtId" label="Id" variant="underlined"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="GrupoTela.grtNome" :rules="nameRules" :counter="200"
                                        label="Nome Grupo" variant="underlined" required></v-text-field>
                                </v-col>

                                <v-col cols="12" md="2">
                                    <v-text-field v-model="GrupoTela.grtOrdem" label="Ordem" type="number"
                                        variant="underlined"></v-text-field>
                                </v-col>

                                <v-col cols="12" md="3">
                                    <v-select v-model="GrupoTela.grtVisivel" label="Visível" :items="Status"
                                        item-title="nome" item-value="grtVisivel" variant="underlined">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="GrupoTela.grtIcon" label="Icone"
                                        variant="underlined"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                    <form>
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <button type="button" @click="Limpar()" class="btn btn-link">
                                    Cancelar
                                </button>
                                <button v-if="GrupoTela.grtId != 0" type="button" class="btn btn-success" @click="Put()">
                                    Alterar
                                </button>
                                <button v-else type="button" class="btn btn-success" @click="Add()">
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box" style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;margin-top: 20px;">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                    required></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    <easy-data-table :headers="headers" :items="preprocessData(GrupoTelas)" v-model="itemsSelected" alternating
                        theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                        body-text-direction="center" rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                        <template #item-grtVisivel="item">
                            <span>{{ item.grtVisivel ? 'Sim' : 'Não' }}</span>
                        </template>
                        <template #item-grtOrdem="item">
                            <span>{{ parseInt(item.grtOrdem) }}</span>
                        </template>
                        <template #item-actions="item">
                            <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                <v-icon>mdi-file-edit-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                            </v-btn>

                            <v-btn icon @click="DeleteGrid(item)" variant="text">
                                <v-icon>mdi-delete-forever-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                            </v-btn>
                        </template>
                    </easy-data-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
export default {
    name: 'GrupoTelasView',
    components: {
        EasyDataTable
    },
    data: () => ({
        GrupoTela: {
            grtId: 0,
            grtNome: '',
            grtOrdem: '',
            grtVisivel: '',
            grtIcon: '',
        },
        GrupoTelas: [],
        selectedVisivel: null,
        Status: [{ nome: "Sim", grtVisivel: true }, { nome: "Não", grtVisivel: false }],
        nameRules: [
            value => {
                if (value?.length <= 200) return true
                return 'Nome pode conter até 200 caracteres.'
            },
        ],

        headers: [
            { text: "Id", value: "grtId", sortable: true, },
            { text: "Nome", value: "grtNome", sortable: true, },
            { text: "Ordem", value: "grtOrdem", sortable: true, },
            { text: "Visivel", value: "grtVisivel", sortable: true, },
            { text: "Icone", value: "grtIcon" },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
    }),
    methods: {
        preprocessData(data) {
            return data.map(item => {
            return {
                ...item,
                grtOrdem: parseInt(item.grtOrdem),
            };
            });
        },
        Limpar() {
            this.GrupoTela.grtId = 0;
            this.GrupoTela.grtNome = '';
            this.GrupoTela.grtOrdem = '';
            this.GrupoTela.grtVisivel = '';
            this.GrupoTela.grtIcon = '';
            this.selectedVisivel = '';
            this.Get();
        },
        Add() {
            if (this.GrupoTela.grtNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.GrupoTela.grtOrdem === ''){
                this.$mensagemAviso("Ordem Obrigatória.")
            }
            else if (this.GrupoTela.grtVisivel === ''){
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else {
                this.GrupoTela.grtOrdem = parseInt(this.GrupoTela.grtOrdem)
                axios.post(`/Process/AdmGrupoTelas/Add`, this.GrupoTela)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        Put() {
            if (this.GrupoTela.grtNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.GrupoTela.grtOrdem === ''){
                this.$mensagemAviso("Ordem Obrigatória.")
            }
            else if (this.GrupoTela.grtVisivel === ''){
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else {
                this.GrupoTela.grtOrdem = parseInt(this.GrupoTela.grtOrdem)
                axios.put(`/Process/AdmGrupoTelas/Update`, this.GrupoTela)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        EditGrid(item) {
            // Lógica para editar o item
            this.GrupoTela = item;
            this.$scrollToTop();
        },
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.grtId;
                axios.delete(`/Process/AdmGrupoTelas/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                        this.Limpar();
                    }
                });
            }
            });
        },
        Get() {
            axios.get(`/Process/AdmGrupoTelas/GetAll`)
                .then(response => {
                    this.GrupoTelas = response.data;
                });
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style></style>
